import styled from 'styled-components';

const HeaderIcon = styled.a`
  cursor: pointer;
`;

export default HeaderIcon;
